<template>
    <div class="console-body-content-item console-video-runtime">
        <div class="console-body-content-item-title">
            <span>Time Executed</span>
        </div>
        <div class="console-body-line">
            <div style="display: block;"
                 v-for="(item, index) in getTimeRangePlayed"
                 :key="index">
                <span class="console-body-text">From {{ item[0] }} To {{item[1]}} seconds</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getTimeRangePlayed = computed(() => {
    return store.getTimeRangePlayed;
});

// METHODS

// LIFECYCLE HOOKS
</script>
